import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { IconNames } from '../../common/constants/icon-names';
import { FieldErrorMessages } from '../field-error-messages/field-error-messages.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-carrier-select',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FieldErrorMessages,
    TranslateModule,
    MatAutocompleteModule,
    SvgIconComponent,
  ],
  templateUrl: './carrier-select.component.html',
  styleUrls: ['./carrier-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// eslint-disable-next-line id-blacklist
export class CarrierSelectComponent<T extends { extId: string; name: string; number: string }> {
  @Input() carriers: T[];
  @Input() fieldControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() testId: string;
  @Input() disableField = false;
  @Input() isLoadMoreEnabled: boolean;
  @Input() loadMoreAmount = 10;

  @Output() optionSelected: EventEmitter<T> = new EventEmitter();
  @Output() loadMore: EventEmitter<{ searchTerm: string; more: number; optionAmount: number }> = new EventEmitter();
  //eslint-disable-next-line @angular-eslint/no-output-native
  @Output() search: EventEmitter<string> = new EventEmitter();

  searchTerm = '';
  iconNames = IconNames;

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    this.optionSelected.emit(event.option.value);
  }

  onLoadMore(): void {
    const optionAmount = this.carriers?.length || 0;

    this.loadMore.emit({ searchTerm: this.searchTerm, more: this.loadMoreAmount, optionAmount });
  }

  searchFn(searchEvent: InputEvent): void {
    const inputElement = searchEvent.target as HTMLInputElement;
    const term = inputElement.value;
    this.searchTerm = term;
    this.search.emit(term);
  }

  displayValueFn(value: T | string): string {
    if (typeof value === 'string') {
      return value;
    }

    return value && value.name ? value.name : '';
  }
}
